export const GlobalCarrierAccessIcon = () => (
    <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M15.4128 4.16199C22.5413 4.16199 28.3064 9.84198 28.3064 16.8309C28.3064 23.8199 22.5414 29.4999 15.4128 29.4999C8.28446 29.4997 2.52026 23.8198 2.52026 16.8309C2.52027 9.84207 8.28446 4.16213 15.4128 4.16199Z" fill="#EDF2FE" stroke="url(#paint0_linear_2652_3307)"/>
    <ellipse cx="4.28571" cy="22.7964" rx="4.28571" ry="4.21407" fill="url(#paint1_linear_2652_3307)"/>
    <ellipse cx="15.9488" cy="4.21407" rx="4.28571" ry="4.21407" fill="url(#paint2_linear_2652_3307)"/>
    <ellipse cx="25.7143" cy="22.7964" rx="4.28571" ry="4.21407" fill="url(#paint3_linear_2652_3307)"/>
    <defs>
    <linearGradient id="paint0_linear_2652_3307" x1="8.71669" y1="8.72697" x2="30.218" y2="24.8786" gradientUnits="userSpaceOnUse">
    <stop stop-color="#4D79F6"/>
    <stop offset="0.889423" stop-color="#1ECAB8"/>
    </linearGradient>
    <linearGradient id="paint1_linear_2652_3307" x1="2.14286" y1="20.2031" x2="9.02327" y2="25.3717" gradientUnits="userSpaceOnUse">
    <stop stop-color="#4D79F6"/>
    <stop offset="0.889423" stop-color="#1ECAB8"/>
    </linearGradient>
    <linearGradient id="paint2_linear_2652_3307" x1="13.8059" y1="1.62079" x2="20.6864" y2="6.78933" gradientUnits="userSpaceOnUse">
    <stop stop-color="#4D79F6"/>
    <stop offset="0.889423" stop-color="#1ECAB8"/>
    </linearGradient>
    <linearGradient id="paint3_linear_2652_3307" x1="23.5714" y1="20.2031" x2="30.4519" y2="25.3717" gradientUnits="userSpaceOnUse">
    <stop stop-color="#4D79F6"/>
    <stop offset="0.889423" stop-color="#1ECAB8"/>
    </linearGradient>
    </defs>
    </svg>
);